import { useApi } from '@/api';
import { TableSkeleton } from '@/components';

import {
  CurrencyValue,
  DataTable,
  EtherScanPictogram,
  Flex,
  RelativeDateTime,
  WalletAddress
} from '@blockanalitica/ui';

import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';

export default function EventsTable({ pagination, sorting, filters }) {
  const [data, error] = useApi({
    url: `/lsev2/events`,
    queryParams: {
      p: pagination.currentPage,
      p_size: pagination.pageSize,
      order: sorting.currentSorting,
      event_name: filters.filtersApplied.eventType
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    const columns: TableColumn[] = [
      {
        header: 'Wallet Address',
        getCell: (row) => <WalletAddress address={row.wallet_address} />,
        columnSize: ['minmax(110px, auto)', 'minmax(150px, auto)']
      },
      {
        header: 'Event',
        getCell: (row) => row.event,
        sortingField: 'event'
      },
      {
        header: 'Amount',
        getCell: (row) => (
          <CurrencyValue
            value={row.amount}
            options={{
              trend: true,
              iconSize: '0',
              currency:
                row.event === 'Wipe' || row.event === 'Draw' ? 'USDS' : 'SKY'
            }}
          />
        ),
        sortingField: 'amount',
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },

      {
        header: 'Time',
        getCell: (row) => (
          <Flex gap="3xs" color="muted">
            <RelativeDateTime value={row.datetime} />
            <a
              href={`https://etherscan.io/tx/${row.tx_hash}`}
              target="_blank"
              rel="noreferrer">
              <EtherScanPictogram size="0" />
            </a>
          </Flex>
        ),
        sortingField: 'order_index',
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      }
    ];

    return (
      <DataTable
        rows={data['results']}
        columns={columns}
        getKey={(row) => row.order_index}
        sorting={sorting}
        pagination={{
          ...pagination,
          totalRecords: data.count
        }}
      />
    );
  }
  return <TableSkeleton />;
}
